export const AddressesHeadline = 'mb-4 text-black font-Roboto'

export const AddressesListWrapper = 'flex flex-col'

export const AddressItemWrapper =
  'flex flex-col border-gray94 border-b border-machine2-75 last-of-type:border-none'

export const AddressAddNewButton = 'mt-5 w-full md:w-1/3 mt-4'

export const AddressSetAsDefaultActionButton =
  'hover:underline underline-offset-4 transition duration-200 order-first'

export const AddressItemContentWrapper =
  'relative flex w-full flex-col p-4 transition duration-400 ease-in-out'

export const AddressItemContentEditModeWrapper = 'bg-accentYellow'

export const AddressItemContentPackstationWrapper = 'bg-[#fafafa]'

export const AddressItemNewDefaultAddressWrapper = 'bg-promotionBg'

export const AddressPreferredAddressLabel =
  'font-Roboto text-10 absolute right-4 bottom-4 sm:bottom-auto sm:top-4 rounded-md bg-black p-2 text-white uppercase'

export const AddressEditModeWrapper = 'flex flex-col pb-4'

export const AddressRemoveDescription =
  'flex w-full pt-4 pb-2 text-black font-bold underline'

export const AddressRemoveNote = 'flex w-full py-4 text-grayRegular text-12'

export const AddressConfirmBoxButtonsWrapper = 'flex w-full justify-end pt-4'
